import {
  DEFAULT_FILTER,
  DEFAULT_WISHLIST_FILTER,
  parseFilter,
  parseWishlistFilter,
  type CollectionFilter,
  type WishlistFilter,
} from '@physical-movies/core';

/**
 * The collection's search, filters and sort, remembered for the tab.
 *
 * Opening a movie unmounts the collection screen, so without this the filter
 * resets the moment you look at something and come back. Session storage
 * rather than the URL because the bottom bar is the other way back here, and a
 * tab link cannot carry the query string; this survives every route back to
 * the collection, and a reload, but not a new tab.
 */

const KEY = 'physical-movies.collectionFilter';

export function readStoredFilter(): CollectionFilter {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    return raw ? parseFilter(JSON.parse(raw)) : DEFAULT_FILTER;
  } catch {
    // Unreadable or malformed storage is not worth failing over.
    return DEFAULT_FILTER;
  }
}

export function writeStoredFilter(filter: CollectionFilter): void {
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify(filter));
  } catch {
    // Private mode and full quotas both land here. The filter still works for
    // as long as the screen is mounted.
  }
}

const WISHLIST_KEY = 'physical-movies.wishlistFilter';

export function readStoredWishlistFilter(): WishlistFilter {
  try {
    const raw = window.sessionStorage.getItem(WISHLIST_KEY);
    return raw ? parseWishlistFilter(JSON.parse(raw)) : DEFAULT_WISHLIST_FILTER;
  } catch {
    return DEFAULT_WISHLIST_FILTER;
  }
}

export function writeStoredWishlistFilter(filter: WishlistFilter): void {
  try {
    window.sessionStorage.setItem(WISHLIST_KEY, JSON.stringify(filter));
  } catch {
    // See above: a filter that cannot be remembered still works while mounted.
  }
}
